import React, { useState } from 'react'
import ProfessionalLoader from '../../components/common/ProfessionalLoader'
import { TableSkeleton, PersonCardSkeleton } from '../../components/common/SkeletonLoader'

const LoaderTest = () => {
  const [showFullScreen, setShowFullScreen] = useState(false)
  const [showSkeleton, setShowSkeleton] = useState(false)

  return (
    <div style={{ padding: '2rem' }}>
      <h1>Loading Animation Test</h1>

      <div style={{ marginBottom: '2rem' }}>
        <h2>1. Full Screen Baseball Loader</h2>
        <button
          onClick={() => setShowFullScreen(!showFullScreen)}
          style={{ padding: '1rem 2rem', fontSize: '16px', cursor: 'pointer' }}
        >
          {showFullScreen ? 'Hide' : 'Show'} Full Screen Loader
        </button>
        {showFullScreen && (
          <ProfessionalLoader message="Loading Rosters..." fullScreen={true} />
        )}
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h2>2. Inline Ring Spinner</h2>
        <ProfessionalLoader message="Please wait..." fullScreen={false} />
      </div>

      <div style={{ marginBottom: '2rem' }}>
        <h2>3. Table Skeleton</h2>
        <button
          onClick={() => setShowSkeleton(!showSkeleton)}
          style={{ padding: '1rem 2rem', fontSize: '16px', cursor: 'pointer', marginBottom: '1rem' }}
        >
          {showSkeleton ? 'Hide' : 'Show'} Skeleton
        </button>
        {showSkeleton && <TableSkeleton rows={5} columns={6} />}
      </div>

      <div>
        <h2>4. Person Card Skeleton</h2>
        <PersonCardSkeleton count={3} />
      </div>
    </div>
  )
}

export default LoaderTest
